import {useCallback, useEffect, useState} from 'react';

import {ApiResponse, ApiResponseError} from '../lib/api/v1/types';

// Creating a simple hook for now, but when we have more time to refactor, we should consider using tanstack query:
// https://tanstack.com/query/latest/docs/react/overview
/**
 * @deprecated
 * @description Please instead use {@link useApiRead}
 */
export function useGetRequest<T>(apiCall: () => Promise<Response>, serializer?: (data: any) => T, manualFetch = false) {
  const [response, setResponse] = useState<ApiResponse<T>>();
  const [isComponentMounted, setIsComponentMounted] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (manualFetch) {
      setLoading(false);
    }
  }, [manualFetch]);

  const request = useCallback(async () => {
    try {
      setLoading(true);
      const response = await apiCall();
      const body = await response.json();

      if (response.ok || (response.status >= 200 && response.status < 300)) {
        const serializedData = serializer ? serializer(body) : body;

        setResponse({
          ok: true,
          data: serializedData,
          error: undefined,
        });
      } else {
        setResponse({
          ok: false,
          data: undefined,
          error: body as ApiResponseError,
        });
      }
    } catch (error: any) {
      console.error(error);
      setResponse({
        ok: false,
        data: undefined,
        error: {
          error_code: 'CLI_0000',
          error_message: 'Web client error',
          extra_details: error.message,
        },
      });
    } finally {
      setLoading(false);
    }
  }, [apiCall, serializer]);

  useEffect(() => {
    if (isComponentMounted && !manualFetch) {
      request();
    }
  }, [request, isComponentMounted, manualFetch]);

  useEffect(() => {
    setIsComponentMounted(true);
  }, []);

  return {
    ...response,
    loading,
    fetchData: request,
  };
}
